export default "__VITE_ASSET__B$RPzyep__"